/**
 * @generated SignedSource<<ea34e68d775eb835b6be5aac8529c07a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActiveProjectsFilter_questions$data = ReadonlyArray<{
  readonly isSurveyMeta: boolean | null | undefined;
  readonly originalId: string;
  readonly responseScaleId: string | null | undefined;
  readonly " $fragmentType": "ActiveProjectsFilter_questions";
}>;
export type ActiveProjectsFilter_questions$key = ReadonlyArray<{
  readonly " $data"?: ActiveProjectsFilter_questions$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActiveProjectsFilter_questions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ActiveProjectsFilter_questions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalId",
      "storageKey": null
    },
    {
      "alias": "responseScaleId",
      "args": null,
      "kind": "ScalarField",
      "name": "originalResponseScaleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSurveyMeta",
      "storageKey": null
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "088926688e8a62c207f77e4ad4e9241e";

export default node;
